import { SECTION_IDS } from '../../../core/constants/navigation';
import Reveal from '../../../common/components/Reveal/Reveal';
import SectionHeading from '../../../common/components/SectionHeading/SectionHeading';
import { IconLayers, IconSearch, IconTarget, IconTrendingUp } from '../../../common/icons';

import '../styles/process.css';

const STEPS = [
    {
        title: 'Diagnóstico',
        text: 'Escuchamos tu proyecto y analizamos tus canales, tu audiencia y tu modelo de negocio.',
        Icon: IconSearch,
    },
    {
        title: 'Estrategia',
        text: 'Definimos objetivos, plan de contenidos, monetización y una ruta clara de crecimiento.',
        Icon: IconTarget,
    },
    {
        title: 'Producción',
        text: 'Creamos, diseñamos y desarrollamos cada pieza con estándares técnicos sólidos.',
        Icon: IconLayers,
    },
    {
        title: 'Acompañamiento',
        text: 'Medimos resultados, optimizamos y seguimos a tu lado en cada paso del proceso.',
        Icon: IconTrendingUp,
    },
];

export default function Process() {
    return (
        <section id={SECTION_IDS.PROCESS} className="process" aria-labelledby="process-title">
            <div className="process__decor" aria-hidden="true" />
            <div className="layout-container">
                <SectionHeading
                    headingId="process-title"
                    eyebrow="Cómo trabajamos"
                    title="Te guiamos de la idea a los resultados"
                    lead="Un proceso claro y colaborativo para que siempre sepas en qué punto está tu proyecto y qué sigue."
                    isInverted
                />

                <ol className="process__steps">
                    {STEPS.map(({ title, text, Icon }, index) => (
                        <Reveal as="li" key={title} delay={index * 120} className="process__step">
                            <div className="process__marker">
                                <span className="process__icon"><Icon /></span>
                                <span className="process__number">Paso {index + 1}</span>
                            </div>
                            <h3 className="process__title">{title}</h3>
                            <p className="process__text">{text}</p>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </section>
    );
}
